import { createIcon } from '@aries/mobile-core/components';

export const IconLogo = createIcon(require('%/assets/logo/logo.png'));
